import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-update-property-status-dialog',
  templateUrl: './update-property-status-dialog.component.html',
  styleUrls: ['./update-property-status-dialog.component.scss'],
  standalone: true,
  imports: [
    MatIcon, 
    CommonModule, 
    MatButtonModule
  ]
})
export class UpdatePropertyStatusDialogComponent implements OnInit {

  selectedProperties!: any[];
  activate: boolean = false;
  deactivateAndInactive: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UpdatePropertyStatusDialogComponent>,
  ) { }

  ngOnInit() {
    this.selectedProperties = this.data;

    let isActivate = this.selectedProperties.some(property => property.status.display_text === "Inactive");
    let isDeactivate = this.selectedProperties.some(property => property.status.display_text === "Active");
    if (isActivate && !isDeactivate) {
      this.activate = true;
    }
    if (!isActivate && isDeactivate) {
      this.activate = false;
    }
    if (isActivate && isDeactivate) {
      this.activate = true;
      this.deactivateAndInactive = true;
    }
  }

  submitUpdatePropertyStatus(activate: boolean) {
    if (activate) {
      this.dialogRef.close(1);
    } else {
      this.dialogRef.close(2);
    }
  }

  cancelUpdatePropertyStatus() {
    this.dialogRef.close(0);
  }
}